import { render, staticRenderFns } from "./addManu.vue?vue&type=template&id=4ecb8342&scoped=true"
import script from "./addManu.vue?vue&type=script&lang=js"
export * from "./addManu.vue?vue&type=script&lang=js"
import style0 from "./addManu.vue?vue&type=style&index=0&id=4ecb8342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb8342",
  null
  
)

export default component.exports